import { MouseEventHandler, PropsWithChildren, ReactNode } from 'react';
import css from './tooltip-wrapper.module.scss';
import TooltipWrapper from './tooltip-wrapper';

interface TooltipProps {
  text: string;
}

export default function Tooltip({ children, text }: PropsWithChildren<TooltipProps>) {
  const wrapper = (
    tooltip: ReactNode,
    onMouseEnter: MouseEventHandler<HTMLDivElement>,
    onMouseLeave: MouseEventHandler<HTMLDivElement>
  ) => (
    <div className={css.tooltipWrapper} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} aria-hidden>
      {children}
      {tooltip}
    </div>
  );

  return <TooltipWrapper text={text} wrapper={wrapper} />;
}
